import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SwapItem from './SwapItem';
import swapProduct from '../../../../../../actions/swapProduct';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => bindActionCreators({ swapProduct }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SwapItem);
